/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Token from 'common/lib/util/token';
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
import { Store } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { getMe } from 'selectors';
import PromiseQueue from './promise-queue';
import TrelloClient from './trello-client-js';

class API {
  client = new TrelloClient({
    getHeaders: () => {
      // will be executed on every request
      const me = getMe(this.store.getState());

      return {
        'X-Trello-Client-Version': window.clientVersion || 'quickload',
        'X-Trello-ReqId': `${me && me.id}-${Math.random()}`,
        //X-Trello-PreferMember: will be necessary for "One Account", please check https://extranet.atlassian.com/display/TRELLO/One+Account%3A+Technical+Implementation+Specification+v2.0
      };
    },
    getToken: () => Token.token || '',
  });
  queue = new PromiseQueue();
  store: Store<State>;

  setStore = (store: Store<State>) => {
    return (this.store = store);
  };
}

export default new API();



// WEBPACK FOOTER //
// ./app/gamma/src/api/index.ts